export default __webpack_public_path__ + "static/media/Eye of Zamora.a0409907.jpg";